import * as React from 'react';
import { Field as FinalField } from 'react-final-form';
import get from 'lodash/get';
import { Checkbox, CheckboxProps } from '@lendi-ui/checkbox';
import Field from '@lendi-ui/field';

import { useFormValues } from '@funnels/hooks';

import { FieldLabel } from '../_common/FieldLabel';
import { FieldWrapper } from '../_common/style';
import { CommonFieldProps } from '../_common/types';

interface CheckboxFieldProps extends CommonFieldProps, Omit<CheckboxProps, 'name' | 'label'> {
  checkboxLabel?: string;
  reverseCheckboxValue?: boolean;
}

const CheckboxField = (props: CheckboxFieldProps) => {
  const {
    label,
    labelAfter,
    name,
    subLabel,
    disableFailMessage = false,
    checkboxLabel,
    onChange,
    reverseCheckboxValue,
    ...rest
  } = props;
  const [formValues, setFormValues] = useFormValues();

  // since checkbox value is opposite to the form value, to make checkbox is unchecked as initial state
  // we have to set targetFormValue as true when the initial formValues in undefined and reverseCheckboxValue flag is on
  const targetFormValue = reverseCheckboxValue ? get(formValues, name, true) : get(formValues, name, false);
  // checkbox's initial state is opposite to target form value is reverseCheckboxValue == true
  const isChecked = reverseCheckboxValue ? !targetFormValue : targetFormValue;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isToChecked = !isChecked;
    // update target form value with opposite state of checkbox if reverseCheckboxValue == true
    const formValueToUpdate = reverseCheckboxValue ? !isToChecked : isToChecked;
    setFormValues(name, formValueToUpdate);
    onChange && onChange(e);
  };

  const fieldProps = {
    name,
  };

  return (
    <FieldWrapper>
      <FieldLabel label={label} labelAfter={labelAfter} subLabel={subLabel} />
      <FinalField {...fieldProps}>
        {({ input, meta }) => (
          <Field {...meta} error={disableFailMessage ? undefined : meta.error}>
            <Checkbox
              {...rest}
              label={checkboxLabel}
              data-component={name}
              isChecked={isChecked}
              onChange={handleChange}
            />
          </Field>
        )}
      </FinalField>
    </FieldWrapper>
  );
};

export default CheckboxField;
